import { reactive, ref } from "@vue/composition-api";
import _axios from "@/axios";
import router from "@/router";

const globalSearchResult = ref([]);

export function useGlobalSearch() {
  let globalSearchData = reactive({
    search: "",
    loading: false,
  });

  async function globalSearch() {
    if (globalSearchData.search) {
      globalSearchData.loading = true;
      return _axios
        .get(`/search?searchTerm=${globalSearchData.search.trim()}`)
        .then((response) => {
          const responseContent = response.data.data;
          const responseType = response.data.type;
          switch (responseType) {
            case "card_details":
              router.push({
                name: "cartes-details",
                params: { id: responseContent.id },
              });
              break;
            case "portal_details":
              router.push({
                name: "portail-details",
                params: { id: response.data.portal.id },
              });
              break;
            case "portal_list":
              globalSearchResult.value = responseContent;
              router.push({
                name: "search-result",
                params: { type: responseType, term: globalSearchData.search },
              });
              break;
            case "no_result":
              globalSearchResult.value = [];
              router.push({
                name: "search-result",
                params: { type: responseType },
              });
              break;
          }
        })
        .catch(() => {
          alert(
            "Une erreur est survenue lors de la recherche, si cela se reproduit contactez le support"
          );
        })
        .finally(() => {
          globalSearchData.loading = false;
        });
    }
  }

  return {
    globalSearchData,
    globalSearchResult,
    globalSearch,
  };
}
